import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';
import Tooltip from '../../tooltip';
import styles from './styles.css';

class SentimentSparkLine extends React.Component {
  static propTypes = {
    recentRatings: PropTypes.arrayOf(PropTypes.shape({
      rating: PropTypes.string,
      created_at: PropTypes.string,
    })),
    maxRecords: PropTypes.number,
  }

  static defaultProps = {
    recentRatings: [],
    maxRecords: 5,
  }

  getColumns() {
    const { recentRatings, maxRecords } = this.props;

    let ratings = [];
    if (recentRatings) {
      ratings = recentRatings;
    }
    // Regardless of data available or not we need to generate 5 spark-lines
    // Also add tooltip for sparkline boxes
    for (let i = 0; i < maxRecords; i += 1) {
      if (ratings.length > i) {
        ratings[i].tooltip = ratings[i].rating;
      } else {
        // When no data, add dummy record
        ratings[i] = {};
        ratings[i].rating = 'NoData';
        ratings[i].tooltip = 'No Data';
        ratings[i].created_at = String(new Date(1, 0, 1));
      }
      ratings[i].key = i;
    }

    ratings.sort((a, b) => (new Date(a.created_at)).getTime() > (new Date(b.created_at)).getTime());

    return ratings.map((r) => {
      const uniqueId = `spark${uuidv4()}`;
      return (
        <span key={uniqueId} id={uniqueId}>
          <span className={`${styles.sparkLine} ${styles[r.rating]}`} />
          <Tooltip
            tootipContent={r.tooltip}
            uniqueTargetSelector={`#${uniqueId}`}
          />
        </span>
      );
    });
  }

  render() {
    return (
      <div className={styles.sentimentSparkLine}>
        {this.getColumns()}
      </div>
    );
  }
}

export default SentimentSparkLine;
